export default __webpack_public_path__ + "static/media/crystal.7a7dadb4.png";